module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "200px"
    }
  }, [_c('mt-palette-button', {
    ref: "target_1",
    staticClass: "pb",
    staticStyle: {
      "left": "30px"
    },
    attrs: {
      "content": "+",
      "direction": "rt",
      "radius": 80,
      "mainButtonStyle": "color:#fff;background-color:#26a2ff;"
    },
    on: {
      "expand": function($event) {
        _vm.main_log('expand')
      },
      "expanded": function($event) {
        _vm.main_log('expanded')
      },
      "collapse": function($event) {
        _vm.main_log('collapse')
      }
    }
  }, [_c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(3)
      }
    }
  })]), _vm._v(" "), _c('mt-palette-button', {
    ref: "target_2",
    staticClass: "pb",
    staticStyle: {
      "left": "calc(50% - 30px)"
    },
    attrs: {
      "content": "+",
      "direction": "t",
      "radius": 80,
      "mainButtonStyle": "color:yellow;background-color:#26a2ff;",
      "offset": Math.PI / 12
    },
    on: {
      "expand": function($event) {
        _vm.main_log('expand')
      },
      "expanded": function($event) {
        _vm.main_log('expanded')
      },
      "collapse": function($event) {
        _vm.main_log('collapse')
      }
    }
  }, [_c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(3)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(4)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(5)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(6)
      }
    }
  })]), _vm._v(" "), _c('mt-palette-button', {
    ref: "target_3",
    staticClass: "pb",
    staticStyle: {
      "right": "30px"
    },
    attrs: {
      "content": "+",
      "direction": "lt",
      "radius": 100
    },
    on: {
      "expand": function($event) {
        _vm.main_log('expand')
      },
      "expanded": function($event) {
        _vm.main_log('expanded')
      },
      "collapse": function($event) {
        _vm.main_log('collapse')
      }
    }
  }, [_c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(3)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(4)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "touchstart": function($event) {
        _vm.sub_log(5)
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10cdc702"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/palette-button.vue
// module id = 266
// module chunks = 0